import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UtilFns } from '@utils';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  templateUrl: './send-confirm-email.component.html',
  styleUrls: ['./auth-shell.scss'],
  imports: [InputTextModule, ButtonModule, FormsModule, RouterModule, CommonModule],
})
export class SendConfirmEmailComponent {
  error = '';
  success = false;
  working = false;
  email = '';
  hasEmail = false;

  constructor(private authService: AuthService) {
    const user = this.authService.getUser();
    this.email = user?.email || '';
    this.hasEmail = !!this.email;
  }

  async onSubmit() {
    this.error = '';
    if (!UtilFns.validateEmail(this.email)) {
      this.error = "Email address is invalid";
      return;
    }
    if (this.working) { return; }
    this.working = true;

    const emailToConfirm = this.hasEmail ? undefined : this.email;

    try {
      await this.authService.sendConfirmEmail(emailToConfirm);
      this.error = '';
      this.success = true;
      this.working = false;
      // setTimeout(() => this.authService.logout(), 10000);

    } catch (err: any) {
      if (err.status === 0) {
        this.error = 'Unable to contact server';
      } else {
        //   this._logger.log(error, 'error');
        this.error = UtilFns.getErrorMessage(err);
      }
      this.working = false;

    }
  }

  async logout() {
    this.authService.logout();
  }

}
